import { Box, Button, Typography } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"

export function ProjectBridgeUploadFilePicker({ value, onChange }) {
    return (
        <Box sx={{ display: "flex", alignItems: "center", gap: 2, pt: 1 }}>
            <Button variant="outlined" component="label" startIcon={<Iconify icon="mdi:file-upload" />}>
                Choose JSON
                <input type="file" accept=".json,application/json" hidden onChange={handleFileChange} />
            </Button>
            <Typography variant="body2" color="text.secondary">
                {value.fileName || "No file selected"}
            </Typography>
        </Box>
    )

    function handleFileChange(event) {
        const file = event.target.files?.[0]
        if (!file) return

        const reader = new FileReader()
        reader.onload = handleLoad
        reader.readAsDataURL(file)

        function handleLoad() {
            onChange({
                fileName: file.name,
                fileData: reader.result,
            })
        }
    }
}
